import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartContext, withCart } from "@insite/client-framework/Components/CartContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";


export interface SavedOrderDetailsNotesStyles {
    titleText?: TypographyProps;
    notesText?: TypographyProps;
    wrapper?: InjectableCss;
}
export const notesStyles: SavedOrderDetailsNotesStyles = {
    wrapper: {
        css: css`
            padding: 20px;
            background-color: ${UCSColors.gray10};
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
            display: flex;
            flex-direction: column;
            padding: 20px;
            gap: 16px;
            margin-top: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                    margin: 10px 16px 0px 16px;
                    gap 0;
                    `,
                ]);
            }}
        `,
    },
    titleText: {
        variant: "h3",
        as: "h3",
        css: css`
            @media print {
                font-size: 14px;
            }
        `,
    },
    notesText: {
        size: 18,
        weight: 400,
        color: UCSColors.gray03,
        css: css`
            line-height: 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            font-size: 17px;
                        `,
                    ],
                    "max",
                );
            }}
            @media print {
                font-size: 12px;
            }
        `,
    },
};

const styles = notesStyles;

const Separator = styled.div`
    height: 1px;
    width: 100%;
    margin: 24px 0;
    background-color: ${UCSColors.gray07};
`;
type Props = WidgetProps & HasCartContext;
const SavedOrderDetailsNotes = ({ cart }: Props) => {
    
    if (!cart || !cart.notes) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Order Notes")}</Typography>
            <Hidden above="sm">
                <Separator />
            </Hidden>
            <Typography {...styles.notesText}>{cart.notes}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withCart(SavedOrderDetailsNotes),
    definition: {
        displayName: "Saved Order Notes",
        allowedContexts: ["SavedOrderDetailsPage"],
        group: "Saved Order Details",
    },
};

export default widgetModule;